(function() {
    'use strict';

    angular.module('product')
        .controller('ExclusionCreateController', ExclusionCreateController);

    ExclusionCreateController.$inject = ['$state', 'productOptionExclusionDataSrvc', 'productOptionDataSrvc', 'productOptionSrvc', 'notificationSrvc', 'exclusionMessagesConst', 'errorNotificationSrvc'];

    function ExclusionCreateController($state, productOptionExclusionDataSrvc, productOptionDataSrvc, productOptionSrvc, notificationSrvc, exclusionMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            option_1: [],
            option_2: [],
            nonFieldErrors: []
        };
        self.exclusionData = {
            option_1: '',
            option_2: ''
        };
        self.options = [];

        self.createExclusion = createExclusion;
        self.cleanErrors = cleanErrors;
        activate();

        function activate() {
            getOptions();
        }

        function getOptions() {
            return productOptionDataSrvc.productOptions()
                .$promise.then(function(response) {
                    self.options = response;
                    return response;
                });
        }

        function createExclusion() {
            productOptionExclusionDataSrvc.create(
                self.exclusionData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", exclusionMessagesConst.add);
                    $state.go('layout.productOptionExclusion.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
